<div class="header">
    <h2>{{ 'users.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="users-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'users.error.unavailable' | translate" />
} @else if (user(); as user) {
    <div class="body">
        <div class="entity-header">
            <div class="entity-avatar">
                <app-avatar [image]="user.avatarId | mediaSrc | async" [label]="user.firstName | initials: user.lastName" size="lg" />
            </div>
            <div class="entity-identity">
                <h1>{{ user.firstName }} {{ user.lastName }}</h1>
                <span class="subtitle">{{ user.email }}</span>
            </div>
            <div class="role-badge">
                <p-tag [value]="user.role" [severity]="user.role | roleSeverity" />
            </div>
        </div>

        <div class="meta-strip">
            @if (user.role === 'organisation_admin') {
                <div class="meta-item">
                    <span class="meta-label">{{ 'users.form.organisation' | translate }}</span>
                    @if (user.organisationId) {
                        <span class="meta-value" app-value-name [id]="user.organisationId" type="organisation"></span>
                    } @else {
                        <span class="meta-value empty">{{ 'common.notProvided' | translate }}</span>
                    }
                </div>
            } @else {
                <div class="meta-item">
                    <span class="meta-label">{{ 'users.form.school' | translate }}</span>
                    @if (user.schoolId) {
                        <span class="meta-value" app-value-name [id]="user.schoolId" type="school"></span>
                    } @else {
                        <span class="meta-value empty">{{ 'common.notProvided' | translate }}</span>
                    }
                </div>
            }
            <div class="meta-item">
                <span class="meta-label">{{ 'users.form.country' | translate }}</span>
                @if (user.country) {
                    <span class="meta-value">{{ user.country | countryName }}</span>
                } @else {
                    <span class="meta-value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
            <div class="meta-item">
                <span class="meta-label">{{ 'users.form.createdAt' | translate }}</span>
                <span class="meta-value">{{ user.createdAt | date: 'mediumDate' }}</span>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'users.form.description' | translate }}</h2>
            @if (user.description) {
                <p class="description">{{ user.description }}</p>
            } @else {
                <p class="description empty">{{ 'common.notProvided' | translate }}</p>
            }
        </div>
    </div>

    <div class="footer">
        <app-delete-button [userId]="user.id" [saving]="saving()" testId="users-view-delete" />
        <p-button [label]="'users.detail.edit' | translate" icon="pi pi-pencil" data-test="users-view-edit" (onClick)="onEdit()" />
    </div>
}
